import { RouteObject } from 'react-router-dom';
import App from './App';
import adminRoutes from './Admin/routing';
import hubRoutes from './Hub/routing';
import sharedRoutes from './shared/navigation/routing';
import { RootRouteErrorBoundary } from './RootBoundary';

const routes: RouteObject[] = [
  {
    element: <App />,
    path: '/',
    children: [...adminRoutes, ...hubRoutes, ...sharedRoutes],
    errorElement: <RootRouteErrorBoundary />,
  },
];

export default routes;
